import { lookupName } from './utils.js';
import { getParamsKey } from '../utility/params.js';

var getLookupState = function getLookupState(state) {
  return state.lookups;
};

var DEFAULT_LOOKUP_CACHE = {};

var getLookupCache = function getLookupCache(state, lookup) {
  var name = lookupName(lookup);
  var lookupState = getLookupState(state);
  return lookupState[name] || DEFAULT_LOOKUP_CACHE;
};

var DEFAULT_LOOKUP_DATA = {};
/**
 * Selects Redux state data for a single lookup
 * @param {object} state Redux state
 * @param {string|object} lookup  A previously registered lookup or its name
 * @param {*} params Optional, parameters that were used for the lookup request to find
 * @param {object} options Additional options for the selector
 * @param {number} options.key Optional, unique key for the lookup request to find. If omitted will be automatically generated from params
 */

var getLookupData = function getLookupData(state, lookup, params) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var cacheState = getLookupCache(state, lookup);
  var key = options.key !== undefined ? options.key : getParamsKey(params);
  return cacheState[key] || DEFAULT_LOOKUP_DATA;
};

export { getLookupCache, getLookupData, getLookupState };
